export enum MobileProviderEnum {
  BASE = "BASE",
  ORANGE = "Orange",
  PROXIMUS = "Proximus",
  TELENETBASE = "Telenet",
  JIM_MOBILE = "Jim Mobile",
  MOBILE_VIKINGS = "Mobile Vikings",
}
